<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Component Imports
import TableViewHeadCell from './TableViewHeadCell'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const primaryKey = computed(() => 'id')
const selectMode = computed(() => viewStore.selectMode || false)
const allSelected = computed(() => viewStore.allSelected || false)
const columns = computed(() => viewStore.visibleColumnIds)

// Methods
const selectAll = () => {
    viewStore.selectAll()
}
</script>

<template>
    <thead>
    <tr>
        <th v-if="!selectMode" :class="{ selected: allSelected }" class="table-cell-select" title="Select all or none"
            @click="selectAll">
            <small><span :class="{ 'bi-square': !allSelected, 'bi-check-square': allSelected }"/></small>
        </th>

        <TableViewHeadCell :column="{ name: primaryKey, title: 'ID#' }" :view-id="viewId"/>

        <TableViewHeadCell v-for="columnId in columns" :key="columnId" :column-id="columnId" :view-id="viewId"/>
    </tr>
    </thead>
</template>